import {
  GET_PRM_DATA_ERROR,
  GET_PRM_DATA_LOADING,
  GET_PRM_DATA_SUCCESS,
} from "../../type/Constant";

let initialState = {
  loading: false,
  user: [],
  error: false,
  errors: [],
  success: false,
  pagination: {},
};

export default function getPrmReducer(state = initialState, action) {
  switch (action.type) {
    case GET_PRM_DATA_LOADING:
      return { ...state, success: false, loading: true };

    case GET_PRM_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        user: action.payload,
        pagination: action.pagination,
      };

    case GET_PRM_DATA_ERROR:
      return { ...state, error: true, errors: action.errors };

    default:
      return state;
  }
}
